import { StoreBenefitsPlaceholderStyled, StoreBenefitsStyled } from './StoreBenefits.style';
import Image from 'components/Basic/Image/Image';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';

type StoreBenefitsProps = {
    acceptGiftCoupon: boolean;
    hasLoyaltyProgram: boolean;
    isPickupPoint: boolean;
    acceptGiftCouponIcon: string | null;
    hasLoyaltyProgramIcon: string | null;
    isPickupPointIcon: string | null;
    isInline?: boolean;
};

const TEST_IDENTIFIER = 'blocks-store-storebenefits';

const StoreBenefits: FC<StoreBenefitsProps> = ({
    isInline = true,
    hasLoyaltyProgram,
    hasLoyaltyProgramIcon,
    isPickupPoint,
    isPickupPointIcon,
    acceptGiftCoupon,
    acceptGiftCouponIcon,
}) => {
    const t = useTypedTranslationFunction();
    const renderPlaceholder = (condition: boolean) => {
        if (condition && isInline) {
            return <StoreBenefitsPlaceholderStyled />;
        }

        return null;
    };

    return (
        <StoreBenefitsStyled $isInline={isInline} data-testid={TEST_IDENTIFIER}>
            {hasLoyaltyProgram && hasLoyaltyProgramIcon && (
                <li className="flex gap-2">
                    <Image
                        src={hasLoyaltyProgramIcon}
                        width="43"
                        height="28"
                        title={t('Tescoma club')}
                        alt={t('Tescoma club')}
                    />
                    {!isInline && t('Tescoma club')}
                </li>
            )}
            {renderPlaceholder(!hasLoyaltyProgram || !hasLoyaltyProgramIcon)}
            {isPickupPoint && isPickupPointIcon && (
                <li className="flex gap-2">
                    <Image
                        src={isPickupPointIcon}
                        width="43"
                        height="28"
                        title={t('E-shop collection point')}
                        alt={t('E-shop collection point')}
                    />
                    {!isInline && t('E-shop collection point')}
                </li>
            )}
            {renderPlaceholder(!isPickupPoint || !isPickupPointIcon)}
            {acceptGiftCoupon && acceptGiftCouponIcon && (
                <li className="flex gap-2">
                    <Image
                        src={acceptGiftCouponIcon}
                        width="43"
                        height="28"
                        title={t('Possibility to use gift vouchers')}
                        alt={t('Possibility to use gift vouchers')}
                    />
                    {!isInline && t('Possibility to use gift vouchers')}
                </li>
            )}
            {renderPlaceholder(!acceptGiftCoupon || !acceptGiftCouponIcon)}
        </StoreBenefitsStyled>
    );
};

export default StoreBenefits;
